// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.step-content[data-v-1d1e517c] {
  padding: 20px;
}
.step-content h3[data-v-1d1e517c] {
  margin-bottom: 10px;
  color: #1a73e8;
  font-size: 20px;
}
.step-description[data-v-1d1e517c] {
  color: #5f6368;
  margin-bottom: 25px;
  font-size: 14px;
}
.cc-section[data-v-1d1e517c] {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 25px;
}
.cc-header[data-v-1d1e517c] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e8eaed;
}
.cc-header h4[data-v-1d1e517c] {
  margin: 0;
  font-size: 18px;
  color: #202124;
  display: flex;
  align-items: center;
  gap: 10px;
}
.cc-header h4 i[data-v-1d1e517c] {
  color: #1a73e8;
}
.cc-count[data-v-1d1e517c] {
  background: #e8f0fe;
  color: #1a73e8;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 600;
}
.cc-input-group[data-v-1d1e517c] {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
.cc-input[data-v-1d1e517c] {
  flex: 1;
  padding: 10px 15px;
  border: 1px solid #dadce0;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
}
.cc-input[data-v-1d1e517c]:focus {
  outline: none;
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}
.btn[data-v-1d1e517c] {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.btn-primary[data-v-1d1e517c] {
  background: #1a73e8;
  color: white;
}
.btn-primary[data-v-1d1e517c]:hover {
  background: #1557b0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.btn-primary[data-v-1d1e517c]:active {
  transform: scale(0.98);
}
.btn-secondary[data-v-1d1e517c] {
  background: #5f6368;
  color: white;
}
.btn-secondary[data-v-1d1e517c]:hover {
  background: #4a4d50;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.btn-secondary[data-v-1d1e517c]:active {
  transform: scale(0.98);
}
.btn[data-v-1d1e517c]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn[data-v-1d1e517c]:disabled:hover {
  box-shadow: none;
  transform: none;
}
.cc-list[data-v-1d1e517c] {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cc-item[data-v-1d1e517c] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border: 1px solid #e8eaed;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.cc-item[data-v-1d1e517c]:hover {
  background: #f1f3f4;
  border-color: #dadce0;
}
.cc-email[data-v-1d1e517c] {
  font-size: 14px;
  color: #202124;
  font-family: 'Roboto Mono', monospace;
}
.btn-remove-cc[data-v-1d1e517c] {
  background: #ea4335;
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}
.btn-remove-cc[data-v-1d1e517c]:hover {
  background: #d33426;
  transform: scale(1.05);
}
.btn-remove-cc[data-v-1d1e517c]:active {
  transform: scale(0.95);
}
.cc-empty[data-v-1d1e517c] {
  padding: 30px;
  text-align: center;
  color: #5f6368;
  font-size: 14px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px dashed #dadce0;
}
`, "",{"version":3,"sources":["webpack://./src/components/wizard/steps/CCRecipientsStep.vue"],"names":[],"mappings":";AA0EA;EACE,aAAa;AACf;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AAEA;EACE,cAAc;AAChB;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;AACvC;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B","sourcesContent":["<template>\n  <div class=\"step-content\">\n    <h3>CC Recipients</h3>\n    <p class=\"step-description\">\n      Add additional email addresses to receive a copy of this notification.\n    </p>\n\n    <!-- CC Section -->\n    <div class=\"cc-section\">\n      <div class=\"cc-header\">\n        <h4><i class=\"fa fa-envelope\"></i> Additional Recipients</h4>\n        <span class=\"cc-count\">{{ ccEmails.length }} CC recipient(s)</span>\n      </div>\n      <div class=\"cc-input-group\">\n        <input\n          type=\"email\"\n          :value=\"newCcEmail\"\n          @input=\"$emit('update:newCcEmail', $event.target.value)\"\n          placeholder=\"Enter email address (e.g., user@example.com)\"\n          class=\"cc-input\"\n          @keyup.enter=\"$emit('add-cc-email')\"\n        />\n        <button\n          type=\"button\"\n          class=\"btn btn-primary btn-sm\"\n          @click=\"$emit('add-cc-email')\"\n        >\n          <i class=\"fa fa-plus\"></i> Add\n        </button>\n        <button\n          type=\"button\"\n          class=\"btn btn-secondary btn-sm\"\n          @click=\"$emit('select-response-team')\"\n          title=\"Select Response Team member(s)\"\n          disabled\n        >\n          <i class=\"fa fa-running\"></i>\n        </button>\n      </div>\n      <div v-if=\"ccEmails.length > 0\" class=\"cc-list\">\n        <div\n          v-for=\"(email, index) in ccEmails\"\n          :key=\"index\"\n          class=\"cc-item\"\n        >\n          <span class=\"cc-email\">{{ email }}</span>\n          <button\n            type=\"button\"\n            class=\"btn-remove-cc\"\n            @click=\"$emit('remove-cc-email', index)\"\n            title=\"Remove email\"\n          >\n            <i class=\"fa fa-times\"></i>\n          </button>\n        </div>\n      </div>\n      <div v-else class=\"cc-empty\">\n        No additional CC recipients added. You can proceed without adding any CC recipients.\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: \"CCRecipientsStep\",\n  props: {\n    ccEmails: { type: Array, required: true },\n    newCcEmail: { type: String, required: true },\n  },\n};\n</script>\n\n<style scoped>\n.step-content {\n  padding: 20px;\n}\n\n.step-content h3 {\n  margin-bottom: 10px;\n  color: #1a73e8;\n  font-size: 20px;\n}\n\n.step-description {\n  color: #5f6368;\n  margin-bottom: 25px;\n  font-size: 14px;\n}\n\n.cc-section {\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 25px;\n}\n\n.cc-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #e8eaed;\n}\n\n.cc-header h4 {\n  margin: 0;\n  font-size: 18px;\n  color: #202124;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.cc-header h4 i {\n  color: #1a73e8;\n}\n\n.cc-count {\n  background: #e8f0fe;\n  color: #1a73e8;\n  padding: 6px 14px;\n  border-radius: 16px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.cc-input-group {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.cc-input {\n  flex: 1;\n  padding: 10px 15px;\n  border: 1px solid #dadce0;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.cc-input:focus {\n  outline: none;\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn-primary {\n  background: #1a73e8;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #1557b0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.btn-primary:active {\n  transform: scale(0.98);\n}\n\n.btn-secondary {\n  background: #5f6368;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #4a4d50;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.btn-secondary:active {\n  transform: scale(0.98);\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn:disabled:hover {\n  box-shadow: none;\n  transform: none;\n}\n\n.cc-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.cc-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border: 1px solid #e8eaed;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.cc-item:hover {\n  background: #f1f3f4;\n  border-color: #dadce0;\n}\n\n.cc-email {\n  font-size: 14px;\n  color: #202124;\n  font-family: 'Roboto Mono', monospace;\n}\n\n.btn-remove-cc {\n  background: #ea4335;\n  color: white;\n  border: none;\n  padding: 6px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s ease;\n}\n\n.btn-remove-cc:hover {\n  background: #d33426;\n  transform: scale(1.05);\n}\n\n.btn-remove-cc:active {\n  transform: scale(0.95);\n}\n\n.cc-empty {\n  padding: 30px;\n  text-align: center;\n  color: #5f6368;\n  font-size: 14px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px dashed #dadce0;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
